// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__K8GzN","info":"PatientInfo_info__17suR"};